import {
  Bot,
  ChartColumnIncreasing,
  ClipboardList,
  Lock,
  Stethoscope,
} from "lucide-react";
import React from "react";

const HealthAssistantCard = () => {
  const insights = [
    {
      icon: Stethoscope,
      title: "Answer health questions",
      description: "What should I know about my medication side effects?",
    },
    {
      icon: ClipboardList,
      title: "Provide care guidance",
      description: "How can I manage my symptoms better today?",
    },
    {
      icon: ChartColumnIncreasing,
      title: "Analyze your health data",
      description: "What trends do you see in my recent lab results?",
    },
  ];
  return (
    <div className="w-full h-[calc(100vh-100px)] flex flex-col items-center justify-center gap-4 p-4">
      <div className="w-full flex flex-col items-center justify-center gap-4">
        <div className="w-full flex flex-col items-center justify-center gap-4">
          <div className="w-16 h-16 bg-[var(--icon-bg-primary)] text-[var(--app-primary)] rounded-xl flex items-center justify-center">
            <Lock className="w-8 h-8" />
          </div>
          <div className="text-xl font-medium mb-2">Health Assistant</div>
        </div>
        <div className="w-full flex flex-col gap-4">
          <div className="text-base text-start text-gray-500">
            Your AI Health Assistant will help:
          </div>
          {insights.map((insight, index) => (
            <div className="w-full" key={index}>
              <div className="flex flex-row items-center justify-between">
                <div className="flex flex-row items-start gap-2">
                  <div className="bg-[var(--icon-bg-primary)] rounded-md p-2">
                    <insight.icon className="w-4 h-4 text-[var(--app-primary)]" />
                  </div>
                  <div>
                    <p className="font-medium text-base mb-1">
                      {insight.title}
                    </p>
                    <p className="text-sm font-light text-gray-500 mb-2">
                      {insight.description}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="w-full text-base text-center border border-dashed border-secondary p-6 rounded-xl bg-white">
          <p className="text-base font-medium text-center leading-relaxed text-secondary">
            Complete document review to start chatting with your health
            assistant
          </p>
        </div>
      </div>
    </div>
  );
};

export default HealthAssistantCard;
